export const getUsernameFromEmail = (email) => {
  return email?.split('@')?.[0] || '';
};